import { useRoutes } from '@folklore/routes';
import classNames from 'classnames';
import { Route } from 'wouter';

import RoundedButton from '../buttons/RoundedButton';

import styles from '../../styles/partials/staff-toolbar.module.css';

interface StaffToolbarProps {
    className?: string;
}

function StaffToolbar({ className }: StaffToolbarProps) {
    const routes = useRoutes();
    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.inner}>
                <Route path={routes.document}>
                    <>
                        <RoundedButton className={styles.button}>Partage</RoundedButton>
                        <RoundedButton
                            href={`https://wordpress.urbania.ca/wp-admin/post.php?post=${1234}&action=edit`}
                            className={styles.button}
                        >
                            Modifier
                        </RoundedButton>
                    </>
                </Route>
                <Route path={routes.survey}>
                    <RoundedButton className={styles.button}>Exporter</RoundedButton>
                </Route>
            </div>
        </div>
    );
}

export default StaffToolbar;
